export default __webpack_public_path__ + "static/media/IMG-20241210-WA0017.e945ab4c.jpg";